module.exports = __webpack_public_path__ + "static/media/react.61e9d7c1.png";